import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import EnhancedHeader from './EnhancedHeader';
import { EnhancedFooter } from './EnhancedFooter';
import '../styles&pics/EnhancedHeaderFooter.css';


function RootLayouts() {
  localStorage.setItem('refresh', '4');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <EnhancedHeader />
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </div>
      <EnhancedFooter />
    </div>
  );
}

export default RootLayouts;
